import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"

export default function Facet({ facet, updatePendingChange, isValueSelected }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)

    const handleCheckboxChange = (value, currentSelected, e) => {
        e.preventDefault()
        updatePendingChange(facet.field, value, !currentSelected)
    }

    if (typeof window !== 'undefined') {
        if (!window.facetToggleFunctions) {
            window.facetToggleFunctions = {}
        }
        window.facetToggleFunctions[facet.field] = toggleProductFilter
    }

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
            <span
                class="ns-anchor ns-d-flex ns-justify-content-between ns-align-items-center ns-relative ns-w-100 ns-border-box pb-xs border-b border-t-brand-accent-01 cursor-pointer"
                data-nosto-element="facet"
                onClick={toggleActive}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <span class="h6 font-medium tracking-[0.16em] text-t-brand-foreground-secondary">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <svg width="10" height="10" aria-hidden='true' focusable='false' role='presentation' viewBox='0 0 10 10' fill='none'>
                    <path d="M9.58337 2.9165L5.00004 6.92692L0.416707 2.9165" stroke="currentColor" stroke-width="0.666667"/>
                </svg>
            </span>
            <div class="ns-sidebar-submenu ns-d-none" id={`${facet.id}-sub-menu`}>
                <ul class="ns-list-unstyled ns-d-flex ns-flex-column ns-d-l-grid" role="menu">
                {facet.data?.map(value => {
                    const selected = isValueSelected(facet.field, value.value, value.selected)
                    
                    return (
                        <li
                            key={value.value}
                            class="ns-d-flex text-body-l leading-none text-t-brand-foreground-secondary"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <Checkbox
                                value={value.value}
                                count={value.count}
                                selected={selected}
                                onChange={(e) => handleCheckboxChange(value.value, selected, e)}
                            />
                        </li>
                    )
                })}
                </ul>
            </div>
        </li>
    )
}
